import { render } from "./FormSocialLinkField.vue?vue&type=template&id=67998b0f&scoped=true"
import script from "./FormSocialLinkField.vue?vue&type=script&lang=js"
export * from "./FormSocialLinkField.vue?vue&type=script&lang=js"

import "./FormSocialLinkField.vue?vue&type=style&index=0&id=67998b0f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-67998b0f"

export default script